<template>
  <v-container grid-list-md>
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        md8
        offset-md2
      >
        <h1> User Detail {{ $route.params.id }} </h1>
        <user-create-update-form
          :id="$route.params.id"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  import UserCreateUpdateForm from '@/components/User/UserCreateUpdateForm'

  export default {
    components: {
      UserCreateUpdateForm
    },
    data () {
      return {
        user: {}
      }
    },
    computed: {
      ...mapGetters([ 'getUser' ])
    },
    created() {
      this.$store.dispatch('ensureUser', this.$route.params.id)
    },
  }
</script>
